import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from '@chakra-ui/react';
import './styles.scss';
const SpinnerUI = () => {
    return (_jsx(Spinner, { thickness: '4px', speed: '0.65s', emptyColor: 'gray.200', color: 'blue.500', size: 'xl' }));
};
export default SpinnerUI;
